import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Grid, IconButton, Tooltip, Typography } from "@mui/material";
import CustomTable from "../../../components/customTable/CustomTable";
import { sipBusinessReportApi } from "../../../app/slices/reports/sipBusinessReportSlice";
import { partnerListApi } from "../../../app/slices/reports/partnerListSlice";
import SearchFilterComponent from "./SearchFilterComponent";
import { createMRTColumnHelper } from "material-react-table";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import ToastComponent from "../../../components/customTable/ToastComponent";

export default function SipBusinessReport() {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const bussinessSliceResponse = useSelector(
    (state) => state.sipBusinessReport.sipBusinessReport.data,
  );
  const { total_amount } = useSelector(
    (state) => state.sipBusinessReport.sipBusinessReport,
  );
  // console.log("total_amount vjhvngvnhmbmnmbhhhjhj", total_amount);

  const sliceResponse = useSelector(
    (state) => state.partnerList.partnerList.data,
  );

  const stateLoading = useSelector((state) => state.sipBusinessReport.loading);

  useEffect(() => {
    if (bussinessSliceResponse) {
      const formattedData = bussinessSliceResponse?.map((originalData) => ({
        id: originalData._id || "N/A",
        // total_amount: originalData.total_amount || "N/A",
        customerRefNo: originalData.customerRefNo || "N/A",
        payment_id: originalData.payment_id || "N/A",
        order_id: originalData.order_id || "N/A",
        quantity: originalData?.result?.data?.quantity || "N/A",
        totalAmount: originalData?.result?.data?.totalAmount || "N/A",
        preTaxAmount: originalData?.result?.data?.preTaxAmount || "N/A",
        metalType: originalData?.result?.data?.metalType || "N/A",
        rate: originalData?.result?.data?.rate || "N/A",
        uniqueId: originalData?.result?.data?.uniqueId || "N/A",
        transactionId: originalData?.result?.data?.transactionId || "N/A",
        userName: originalData?.result?.data?.userName || "N/A",
        merchantTransactionId:
          originalData?.result?.data?.merchantTransactionId || "N/A",
        mobileNumber: originalData?.result?.data?.mobileNumber || "N/A",
        goldBalance: originalData?.result?.data?.goldBalance || "N/A",
        silverBalance: originalData?.result?.data?.silverBalance || "N/A",
        totalTaxAmount:
          originalData?.result?.data?.taxes?.totalTaxAmount || "N/A",
        cgstTaxAmount:
          originalData?.result?.data?.taxes?.taxSplit?.find(
            (tax) => tax.type === "CGST",
          )?.taxAmount || "N/A",
        sgstTaxAmount:
          originalData?.result?.data?.taxes?.taxSplit?.find(
            (tax) => tax.type === "SGST",
          )?.taxAmount || "N/A",
        invoiceNumber: originalData?.result?.data?.invoiceNumber || "N/A",
        referenceType: originalData?.result?.data?.referenceType || "N/A",
        referenceId: originalData?.result?.data?.referenceId || "N/A",
        flag: originalData.flag || "N/A",
        partner_id: originalData.partner_id || "N/A",
        createdAt: originalData.createdAt || "N/A",
        updatedAt: originalData.updatedAt || "N/A",
      }));
      setData(formattedData || []);
    }
  }, [bussinessSliceResponse]);

  const handleSearch = (params) => {
    dispatch(sipBusinessReportApi(params));
  };

  useEffect(() => {
    dispatch(partnerListApi());
    dispatch(sipBusinessReportApi({})); // Trigger the API call without parameters
  }, [dispatch]);

  const columnHelper = createMRTColumnHelper();
  const columns = [
    columnHelper.accessor("id", {
      header: "ID",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.id);
          toast.success("Copied to clipboard!");
        };
        return (
          <Tooltip title={cell.row?.original?.id}>
            <IconButton onClick={handleCopy}>
              <ContentCopy />
            </IconButton>
          </Tooltip>
        );
      },
    }),

    columnHelper.accessor("userName", {
      header: "User Name",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.userName}</div>,
    }),

    columnHelper.accessor("customerRefNo", {
      header: "Customer Ref No",
      size: 30,
      Cell: ({ cell }) => {
        const handleCopy = () => {
          navigator.clipboard.writeText(cell.row?.original?.customerRefNo);
          toast.success("Copied to clipboard!");
        };
        return (
          <>
            <Tooltip title={cell.row?.original?.customerRefNo}>
              <IconButton onClick={handleCopy}>
                <ContentCopy />
              </IconButton>
            </Tooltip>
            {cell.row?.original?.customerRefNo}
          </>
        );
      },
    }),
    columnHelper.accessor("payment_id", {
      header: "Payment ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.payment_id}</div>,
    }),
    columnHelper.accessor("order_id", {
      header: "Order ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.order_id}</div>,
    }),
    columnHelper.accessor("quantity", {
      header: "Quantity",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.quantity}</div>,
    }),
    columnHelper.accessor("totalAmount", {
      header: "Total Amount",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.totalAmount}</div>,
    }),
    columnHelper.accessor("preTaxAmount", {
      header: "Pre-Tax Amount",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.preTaxAmount}</div>,
    }),
    columnHelper.accessor("metalType", {
      header: "Metal Type",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.metalType}</div>,
    }),
    columnHelper.accessor("rate", {
      header: "Rate",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.rate}</div>,
    }),
    columnHelper.accessor("uniqueId", {
      header: "Unique ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.uniqueId}</div>,
    }),
    columnHelper.accessor("transactionId", {
      header: "Transaction ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.transactionId}</div>,
    }),

    columnHelper.accessor("mobileNumber", {
      header: "Mobile Number",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.mobileNumber}</div>,
    }),
    columnHelper.accessor("goldBalance", {
      header: "Gold Balance",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.goldBalance}</div>,
    }),
    columnHelper.accessor("silverBalance", {
      header: "Silver Balance",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.silverBalance}</div>,
    }),
    columnHelper.accessor("invoiceNumber", {
      header: "Invoice Number",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.invoiceNumber}</div>,
    }),
    columnHelper.accessor("flag", {
      header: "Flag",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.flag}</div>,
    }),
    columnHelper.accessor("partner_id", {
      header: "Partner ID",
      size: 30,
      Cell: ({ cell }) => <div>{cell.row?.original?.partner_id}</div>,
    }),
    columnHelper.accessor("createdAt", {
      header: "Created At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.createdAt).toLocaleDateString()}
        </div>
      ),
    }),
    columnHelper.accessor("updatedAt", {
      header: "Updated At",
      size: 30,
      Cell: ({ cell }) => (
        <div>
          {new Date(cell.row?.original?.updatedAt).toLocaleDateString()}
        </div>
      ),
    }),
  ];

  return (
    <>
      {/*  */}

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          // justifyContent: "flex-start",
          p: { xs: 1, md: 3 },
          // border: "1px solid grey",
          mb: { xs: 1, md: 3 },
          background: "#dcdaff",
          color: "#4d16a4",
          borderRadius: "6px",
        }}
      >
        <Box sx={{ marginLeft: { xs: 0 } }}>
          <Typography variant={{ xs: "h2" }} component="div">
            Total Amount
          </Typography>
          <Typography variant="body1" component="div">
            Batuk Partner
          </Typography>
        </Box>
        <Box sx={{ marginRight: { xs: 0 } }}>
          <Typography variant={{ xs: "body2" }} component="div">
            ₹ {total_amount}
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={{ xs: 1, md: 3 }}>
        <Grid item xs={12}>
          <SearchFilterComponent
            sliceResponse={sliceResponse}
            onSearch={handleSearch}
          />
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            columns={columns}
            data={data}
            loading={stateLoading}
            permissionKey="SIPBussinessReport"
          />
        </Grid>
      </Grid>
    </>
  );
}
